import {
  ArticleCardSkeleton,
  FilterBoxSkeleton,
} from '@dustin-web/microsite-components/src/skeleton'

export const BlogSkeleton = () => {
  return (
    <>
      <div className="d-none d-lg-block col-lg-3">
        <FilterBoxSkeleton />
      </div>
      <div className="col-12 col-lg-9">
        <div className="row sm-gutters">
          {[...new Array(9)].map((_, i) => (
            <div key={i} className="col-md-6 u-mb-16 col-lg-4">
              <ArticleCardSkeleton />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
